"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cross = exports.Tag = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-15rd9br-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n"])));

exports.Container = Container;

var Tag = _styledComponents["default"].div.withConfig({
  displayName: "styled__Tag",
  componentId: "sc-15rd9br-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 24px;\n    padding: 12px;\n    display: inline-block;\n    margin-right: 15px;\n    margin-bottom: 15px;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    cursor: pointer;\n    transition: color 0.2s ease-in;\n    background-color: ", ";\n    user-select: none;\n    @media (min-width: 500px) {\n        &:hover {\n            color: ", ";\n        }\n    }\n"])), function (props) {
  return props.active ? _constants.COLORS.darkGrey : _constants.COLORS.grey;
}, function (props) {
  return props.active ? _constants.COLORS.white : _constants.COLORS.lightGrey;
}, _constants.COLORS.red);

exports.Tag = Tag;

var Cross = _styledComponents["default"].img.withConfig({
  displayName: "styled__Cross",
  componentId: "sc-15rd9br-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: ", ";\n    width: 10px;\n    height: 10px;\n    margin-left: 10px;\n"])), function (props) {
  return props.active ? 'inline-block' : 'none';
});

exports.Cross = Cross;